import { render, staticRenderFns } from "./PatreonSyncs.vue?vue&type=template&id=69c23ac6&scoped=true"
import script from "./PatreonSyncs.vue?vue&type=script&lang=js"
export * from "./PatreonSyncs.vue?vue&type=script&lang=js"
import style0 from "./PatreonSyncs.vue?vue&type=style&index=0&id=69c23ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c23ac6",
  null
  
)

export default component.exports